import {
	Component, Input, Output, EventEmitter, OnInit, OnChanges, SimpleChanges, SimpleChange,
	ChangeDetectionStrategy, ChangeDetectorRef, ViewChild, ViewChildren, QueryList, ElementRef
} from '@angular/core';
import { IpAddress } from 'DiscoveryEngine.TS/Core';
import { Iterable } from 'DiscoveryEngine.TS/Utils';
import { DisplayDeviceListDto, DisplayDeviceListEntryDto } from 'UvExplorerServer.Dtos.TS/Session';
//import { Table } from 'primeng/table';
import { UvTable } from 'widget';


export class DevicePreviewEntry {
	public dataKey: string;
	public name: string;
	public ipAddress: string;
	public description: string;

	public ipAddressTag: IpAddress;
	public get hasIpAddressTag(): boolean {
		return !!this.ipAddressTag;
	}

	public deviceTag: DisplayDeviceListEntryDto;
	public get hasDeviceTag(): boolean {
		return !!this.deviceTag;
	}

	constructor() {
		this.dataKey = "";
		this.name = "";
		this.ipAddress = "";
		this.description = "";

		this.ipAddressTag = null;

		this.deviceTag = null;
	}
}


@Component({
	selector: 'device-preview',
	templateUrl: './device-preview.component.html',
	styleUrls: ['./device-preview.component.scss'],
	changeDetection: ChangeDetectionStrategy.OnPush
})
export class DevicePreviewComponent implements OnInit, OnChanges {

	@Input()
	public header: string;

	@Input()
	public visible: boolean;

	@Input()
	public devices: DisplayDeviceListDto;

	@Input()
	public modal: boolean;

	@Output()
	public visibleChange: EventEmitter<boolean>;

	@ViewChild('table', { static: true })
	public table: UvTable;

	@ViewChildren('filter')
	public filters: QueryList<ElementRef<HTMLInputElement>>;

	public cols: any[];
	public entries: DevicePreviewEntry[];
	
	public readonly VirtualScrollItemSize = 29;
	public get TableRowStyle(): string {
		return `height: ${this.VirtualScrollItemSize}px;`;
	}

	public doCustomSort(event): void {
		let comparer = function (a: DevicePreviewEntry, b: DevicePreviewEntry): number {
			let result = 0;

			switch (event.field) {
				case "ipAddress":
					if (a.ipAddressTag && b.ipAddressTag) {
						result = a.ipAddressTag.CompareTo(b.ipAddressTag);
					}
					else if (a.ipAddressTag) {
						result = 1;
					}
					else if (b.ipAddressTag) {
						result = -1;
					}
					break;
				default:
					// Compare string fields
					result = a[event.field].localeCompare(b[event.field]);
					break;
			}

			return result * event.order;
		}

		this.entries.sort(comparer);
	}

	constructor(private changeDetector: ChangeDetectorRef) {
		this.header = "";
		this.visible = false;
		this.devices = null;
		this.modal = true;
		this.visibleChange = new EventEmitter<boolean>();
		this.cols = [
			{ field: 'name', header: 'Name', sortable: "custom", sortFunction: (event) => this.doCustomSort(event), filterMatchMode: "contains" },
			{ field: 'ipAddress', header: 'IP Address', sortable: "custom", sortFunction: (event) => this.doCustomSort(event), filterMatchMode: "contains" },
			{ field: 'description', header: 'Description', sortable: "custom", sortFunction: (event) => this.doCustomSort(event), filterMatchMode: "contains" },
		];
		this.entries = [];
	}

	public get totalDeviceCount(): number {
		if (this.entries)
			return this.entries.length;
		else
			return 0;
	}

	public show(): void {
		this.visible = true;
		this.visibleChange.emit(true);

		this.changeDetector.markForCheck();
	}
	public hide(): void {
		this.visible = false;
		this.visibleChange.emit(false);

		this.changeDetector.markForCheck();
	}

	public ngOnInit(): void {
		this.rebuildEntries();
	}

	public ngOnChanges(changes: SimpleChanges): void {
		let change: SimpleChange = null;
		
		change = changes["devices"];
		if (change) {
			this.rebuildEntries();
		}

		change = changes["visible"];
		if (change) {
			if (this.visible) {

				if (this.filters) {
					this.filters.forEach((filter: ElementRef<HTMLInputElement>) => {
						filter.nativeElement.value = "";
					});
				}

				this.cols.forEach((col) => {
					this.table.filter("", col.field, col.filterMatchMode)
				});
			}
		}
	}

	public onFilterChange(): void {

	}

	private rebuildEntries(): void {

		this.changeDetector.markForCheck();

		this.entries = [];

		if (this.devices && this.devices.entries) {
			this.devices.entries.forEach((device: DisplayDeviceListEntryDto) => {

				let entry = new DevicePreviewEntry();

				entry.dataKey = device.deviceGuid;
				entry.deviceTag = device;
				entry.name = device.name;

				entry.ipAddress = "";
				entry.ipAddressTag = null;
				if (device.ipAddress) {
					entry.ipAddress = device.ipAddress;
					entry.ipAddressTag = IpAddress.Create(device.ipAddress);
				}

				entry.description = device.systemDescription;

				this.entries.push(entry);

			}, this);
		}
	}

}
